import React from "react"
import {Form, Formik} from "formik"

export default function FormBuilder({
                                      initialValues,
                                      validationSchema,
                                      onSubmit,
                                      children,
                                      enableReinitialize = false,
                                      classCustom = ''
                                    }) {
  return (
    <div className="formik">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={enableReinitialize}
      >
        {({
            handleSubmit,
            isSubmitting,
            values,
            errors,
            touched,
            setFieldValue,
            setFieldTouched,
            submitForm
          }) => (
          <Form onSubmit={handleSubmit} className={classCustom}>
            {typeof children === "function"
              ? children({
                isSubmitting,
                values,
                errors,
                touched,
                setFieldValue,
                setFieldTouched,
                submitForm
              })
              : children}
          </Form>
        )}
      </Formik>
    </div>
  )
}